.link {
    padding-block: var(--spacer-4);
    font: var(--font-nav-16);
    box-shadow: inset 0 0 0 0 currentcolor;
    transition: box-shadow 0.2s;
    white-space: nowrap;

    &:hover {
        box-shadow: inset 0 -1px 0 0 currentcolor;
    }
}

.submenuTrigger {
    composes: link;
    position: relative;
}

.submenuTriggerActive {
    composes: submenuTrigger;
    box-shadow: inset 0 -1px 0 0 currentcolor;

    // Hover hitbox, play with this if someone complains about the submenu
    // closing when mousing from trigger to menu
    &::after {
        --width: -200%;
        --height: 24px;

        content: "";
        position: absolute;
        left: var(--width);
        right: var(--width);
        bottom: calc(var(--height) * -1);
        height: var(--height);
    }
}

.searchTrigger {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--spacer-32);
    height: var(--spacer-32);
    color: inherit;
}

.searchTriggerIcon {
    width: var(--spacer-24);
    height: var(--spacer-24);
    fill: currentcolor;
}

.divider {
    display: block;
    width: 1px;
    height: 24px;
    background: currentcolor;
    flex-shrink: 0;
}
